<template>
  <v-app>
    <v-container>
     <v-flex xs12>
     <v-breadcrumbs large :items="items" divider=">"></v-breadcrumbs>
     </v-flex>
      <v-toolbar flat color="white">
        <v-toolbar-title>Manage Clients</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = !dialog" color="primary" dark class="mb-2">New Client</v-btn>
      </v-toolbar>

      <v-data-table :headers="headers" :items="ClientsFromDB" class="elevation-1">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.createdDate }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.address }}</td>
          <td>{{ props.item.phone }}</td>
          <td>{{ props.item.email }}</td>
          <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
            <v-icon small @click.stop="deleteDialog = true;name=props.item.name">build</v-icon>
          </td>
        </template>
      </v-data-table>

      <v-dialog v-model="deleteDialog" max-width="290">
        <v-card>
          <v-card-title style="color:red" class="headline">Delete</v-card-title>
          <v-card-text>Are you sure you want to delete Client: {{name}} ?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" flat="flat" @click="deleteDialog = false">Cancel</v-btn>

            <v-btn
              color="primary"
              flat="flat"
              @click="deleteDialog = false; deleteItem(name)"
            >Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-dialog v-model="dialog" width="800px" :persistent="dialogPersis">
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title">{{formTitle}}</v-card-title>
        <v-container grid-list-sm class="pa-4">
          <v-form ref="form">
            <v-text-field
             :disabled='editName'
              required
              v-model="newClientModel.name"
              :rules="nameRules"
              placeholder="Client Name"
            >{{newClientModel.name}}</v-text-field>

            <v-text-field
              v-model="newClientModel.address"
              placeholder="Client Address"
            >{{newClientModel.address}}</v-text-field>
            <v-text-field
              v-model="newClientModel.phone"
              placeholder="Client Phone Number"
            >{{newClientModel.phone}}</v-text-field>
            <v-text-field
              v-model="newClientModel.email"
              placeholder="Client Email Address"
            >{{newClientModel.email}}</v-text-field>
            <v-layout>
              <v-flex xs6 md6>
                <p
                  v-for="(message,index) in messages"
                  v-bind:key="index"
                  class="red--text"
                >{{message}}</p>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn flat @click="close">Cancel</v-btn>
          <v-btn flat color="primary" @click="createClient()">{{buttonText}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>


<script>
const fb = require("../firebaseConfig.js");
 import { mapFields } from "vuex-map-fields";

export default {
  name: "Clients",
  components: {
  },
  data() {
    return {
      editName : false,
       items: [
        {
          text: 'Home',
          disabled: false,
          to: 'home'
        },
        {
          text: 'Clients',
          disabled: false,
          to: 'clients'
        },
      ],
      editedIndex: -1,
      clientList: [],
      dialogPersis: true,
      nameRules: [v => !!v || "Client Name is required"],
      valid: false,
      messages: [],
      name: null,
      deleteDialog: false,
      currentOBJ: null,
      headers: [
        { text: "Created", value: "createdDate" },
        { text: "Name", value: "name" },
        { text: "Address", value: "address" },
        { text: "Phone Number", value: "phone" },
        { text: "Contact Email", value: "email" },
        { text: "Actions", value: "", sortable: false }
      ],
      dialog: false,
      assetsUI: null,
      ClientsFromDB: [],
      editedItem: {
        createdDate: this.$moment().format("YYYY-MM-DD"),
        name: "",
        phone: "",
        address: "",
        email: "",
        locations: [],
        lots : []
      },
      newClientModel: {
        createdDate: this.$moment().format("YYYY-MM-DD"),
        name: "",
        phone: "",
        address: "",
        email: "",
        locations: [],
        lots : []
      }
    };
  },
  watch : {
    editedIndex : function(val){
      if(val === -1){
        this.editName = false
      }else{
        this.editName = true
      }
    }
  },
  computed: {
    ...mapFields(["snackBarMessage",
        "snackBar","snackBarcolor"]),
    formTitle() {
      return this.editedIndex === -1 ? "Create new Client" : "Edit Client";
    },
    buttonText() {
      return this.editedIndex === -1 ? "Create" : "Edit";
    }
  },
  methods: {
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.newClientModel = Object.assign({}, this.editedItem);
        this.editedIndex = -1;
      }, 300);
    },
    editItem(item) {
      this.editedIndex = this.ClientsFromDB.indexOf(item);
      this.newClientModel = Object.assign({}, item);

      this.dialog = true;
    },
    createClient() {
      var pRef = fb.CustomersCollections.doc(this.newClientModel.name);
      if (this.editedIndex === -1) {
        //create new client
        if (
          !this.$refs.form.validate() ||
          this.clientList.includes(this.newClientModel.name)
        ) {
          this.snackBar = true;
          this.snackBarcolor = "red";
          this.snackBarMessage = "Client Already Exist";
          return;
        }
        pRef.get().then(doc => {
          if (!doc.exists) {
            pRef.set(this.newClientModel).then(() => {
              this.snackBar = true;
              this.snackBarcolor = "green";
              this.snackBarMessage =
                "Client " + this.newClientModel.name + " Created";
              this.close();
            });
          }
        });
      } else {
        //edit client
        pRef.get().then(doc => {
          if (!doc.exists) {
            this.snackBar = true;
            this.snackBarcolor = "red";
            this.snackBarMessage = "Client does not Exist";
          } else {
            //edit client
            pRef.set(this.newClientModel).then(() => {
              this.snackBar = true;
              this.snackBarcolor = "green";
              this.snackBarMessage =
                "Client " + this.newClientModel.name + " Updated";
              this.close();
            });
          }
        });
      }

      this.valid = false;
      this.dialog = false;
    },
    deleteItem(name) {
      //remove asset collection association
      //remove pallet association in customers collection
      //remove from Client collection
      fb.AssetsCollections.where("Discovery.Client", "==", name)
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            fb.AssetsCollections.doc(doc.id).update({
              "Discovery.Client": null
            });
          });
        });
      fb.LocationsCollections.where("Clients", "array-contains", name)
        .get()
        .then(items => {
          if (!items.empty) {
            items.forEach(item => {
              fb.LocationsCollections.doc(item.id).update({
                Clients: fb.firestore.FieldValue.arrayRemove(name)
              });
            });
          }
        });
      fb.CustomersCollections.doc(name).delete();
    }
  },
  mounted() {
    fb.CustomersCollections.onSnapshot(docs => {
      docs.forEach(doc => {
        this.clientList.push(doc.id);
      });
    });
    fb.CustomersCollections.onSnapshot(querySnapshot => {
      this.ClientsFromDB = [];
      querySnapshot.forEach(doc => {
        this.ClientsFromDB.push(doc.data());
      });
    });
  }
};
</script>


<style>
.iconPic {
  width: 40px;
  margin-left: 1%;
}
</style>